import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useQuery } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import CenteredSpinner from './CenteredSpinner';
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { getAddressFullName } from '../Utils';

export const AddBuyerProperties = () => {
  const location = useLocation();
  const [search, setSearch] = useState('');
  const [staffMemberId] = useState(
    localStorage.getItem('staffMemberId'),
  );
  const [searchPastBuyer, setSearchPastBuyer] = useState(null);
  //PastBuyerRef will always have a reference of searchPastBuyer value
  const pastBuyerRef = useRef();
  pastBuyerRef.current = searchPastBuyer;
  const navigate = useNavigate();
  const [checked, setChecked] = useState([]);

  useEffect(() => {
    refetch();
  }, [
    searchPastBuyer,
    location?.state?.propertyId
  ]);

  const fetchClients = () => {
    const options = {
      method: 'POST',
      url: '/buyer/getmobilebuyerlist',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        negotiatorId: staffMemberId,
        searchPastBuyers: pastBuyerRef.current,
      }),
    };

    return axios
      .request(options)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw new Error('Server error');
      });
  };

  const postBuyerProperties = () => {
    let data = [];

    checked.forEach((buyerSpecId) => {
      data.push(
        {
          BuyerSpecId: parseInt(buyerSpecId),
          PropertyId: location?.state?.propertyId,
          Status: 3
        }
      )
    });

    const options = {
      method: 'POST',
      url: '/BuyerProperty/AddFromCrossMatch',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    };

    return axios
      .request(options)
      .then((response) => {
        toast.success(
          `Properties added successfully`,
          {
            position: 'top-center',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
        navigate(-1);
      })
      .catch((error) => {
        toast.error(`Sorry, server error, try again later`, {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const {
    isLoading: isLoadingClients,
    isError,
    data: ClientsData,
    refetch
  } = useQuery('ClientsData', fetchClients, {
    refetchOnWindowFocus: false,
    enabled: false // turned off by default, manual refetch is needed
  });

  const filterClient = (clients, search) => {
    if (!search) {
      return clients;
    }

    return clients.filter((client) => {
      if (client?.address?.addressIndividualFirstName != null) {
        return (
          client?.address?.addressIndividualFirstName?.toLowerCase()
            .includes(search.toLowerCase()) ||
          client?.address?.addressIndividualSurname?.toLowerCase()
            .includes(search.toLowerCase()) ||
          client?.buyerSpec?.buyerSpecName?.toLowerCase()
            .includes(search.toLowerCase())
        );
      }
    });
  };

  const filterClients = filterClient(ClientsData, search);

  const handleCloseModal = (event) => {
    navigate(-1);
  }

  // Add/Remove checked item from list
  const handleCheck = (event) => {
    var updatedList = [...checked];
    if (event.target.checked) {
      updatedList = [...checked, event.target.value];
    } else {
      updatedList.splice(checked.indexOf(event.target.value), 1);
    }
    setChecked(updatedList);
  };

  if (isLoadingClients) {
    return <CenteredSpinner />;
  }

  if (isError) {
    return (
      <div className="container">
        <div className="row justify-content-center align-items-center vh-100">
          <h1>Server is down, please try again later </h1>
        </div>
      </div>
    );
  }

  return (
    <Modal show={true} centered backdrop="static" dialogClassName="property-modal">
      <Modal.Header closeButton onClick={handleCloseModal}>
        <Modal.Title><span className="font-weight-bold">Add Property To Buyer</span></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="property-details-card mb-3">
          <div className="buyer-modal-summary">
            <div>
              <p className="mb-1 text-muted small">Available buyers</p>
              <h6 className="mb-0">
                You have{' '}
                {filterClients?.length > 1
                  ? `${filterClients?.length} clients`
                  : `${filterClients?.length} client`}
              </h6>
            </div>
            <div className="buyer-modal-count">
              {filterClients?.length ?? 0}
            </div>
          </div>
          <div className="form-group has-search buyer-modal-search">
            <span className="fa fa-search form-control-feedback"></span>
            <input
              type="text"
              className="form-control"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        {filterClients?.length < 1 ? (
          <h5 className="text-center text-muted">No search results found</h5>
        ) : null}

        <div className="buyer-modal-list">
          {filterClients &&
            React.Children.toArray(
              filterClients?.map((buyer) => {
                const checkboxId = `buyer-${buyer?.buyerSpecId}`;
                return (
                  <div className="buyer-modal-item d-flex align-items-center">
                    <div className="buyer-modal-check">
                      <input
                        id={checkboxId}
                        type="checkbox"
                        value={buyer?.buyerSpecId}
                        onChange={handleCheck}
                      />
                    </div>
                    <div className="buyer-modal-text">
                      <label htmlFor={checkboxId} className="buyer-modal-name cursor-item">
                        {getAddressFullName(buyer?.address) === ''
                          ? buyer?.buyerSpec?.buyerSpecName
                          : getAddressFullName(buyer?.address)}
                      </label>
                      <div className="buyer-modal-ref">Buyer Ref: {buyer?.buyerRef}</div>
                    </div>
                  </div>
                );
              }),
            )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleCloseModal}>
          Cancel
        </Button>
        <Button onClick={postBuyerProperties}>
          Add
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
